'use client';

import { useState, useEffect, useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function GifCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  
  const images = [
    "https://pub-120195864a0046c49ac9d9af4171257f.r2.dev/reasoning-ai.gif",
    "https://pub-120195864a0046c49ac9d9af4171257f.r2.dev/qwq32-reasoning.gif"
  ];
  
  // 预估的GIF播放时间（毫秒）
  const gifDurations = [8000, 8000];
  
  const goToNext = () => {
    if (isTransitioning) return;
    
    setIsTransitioning(true);
    setCurrentIndex((prev) => (prev === 0 ? 1 : 0));
    
    // 过渡动画结束后重置状态
    setTimeout(() => {
      setIsTransitioning(false);
    }, 500); // 过渡动画时长
  };
  
  const startTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    
    timerRef.current = setTimeout(() => {
      goToNext();
    }, gifDurations[currentIndex]);
  };
  
  // 当索引变化时重新开始计时
  useEffect(() => {
    startTimer();
    
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [currentIndex, isTransitioning]);
  
  return (
    <div className="relative h-[300px] w-full flex justify-center">
      {/* 主容器 */}
      <div className="relative overflow-hidden rounded-lg shadow-md max-w-full md:max-w-2xl">
        {/* 图片容器 */}
        <div className="relative">
          {images.map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`seek v3 演示 ${index + 1}`}
              className={`
                transition-opacity duration-500
                ${currentIndex === index ? 'opacity-100' : 'opacity-0'}
                ${index === 0 ? 'absolute inset-0' : ''}
              `}
              style={{ zIndex: currentIndex === index ? 10 : 0 }}
            />
          ))}
        </div>
        
        {/* 控制按钮 - 可选 */}
        <div className="absolute inset-0 flex items-center justify-between p-2 opacity-0 hover:opacity-100 transition-opacity">
          <button 
            onClick={(e) => {
              e.preventDefault();
              setCurrentIndex(0);
            }}
            className="bg-black/30 text-white p-1 rounded-full hover:bg-black/50"
          >
            <ChevronLeft size={20} />
          </button>
          <button 
            onClick={(e) => {
              e.preventDefault();
              setCurrentIndex(1);
            }}
            className="bg-black/30 text-white p-1 rounded-full hover:bg-black/50"
          >
            <ChevronRight size={20} />
          </button>
        </div>
        
        {/* 指示器 */}
        <div className="absolute bottom-2 left-0 right-0 flex justify-center gap-2">
          {images.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-2 h-2 rounded-full transition-all ${
                currentIndex === index ? 'bg-white scale-125' : 'bg-white/50'
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
